import { useCallback, useMemo } from 'react';

import { format } from 'date-fns';

import { useDateLocalize } from './locales/useDateLocalize.js';

const useDateFormatter = (from?: Date, to?: Date, dateFormat?: string) => {
  const localize = useDateLocalize();

  const formatDate = useCallback(
    (date: Date, dateFormat?: string) =>
      date &&
      format(date, dateFormat ?? 'P', {
        locale: localize,
      }),
    [localize],
  );

  const formattedDateFrom = useMemo(() => {
    if (from) {
      return `${formatDate(from, dateFormat)}`;
    }
    return '';
  }, [formatDate, from]);

  const formattedDateTo = useMemo(() => {
    if (to) {
      return `${formatDate(to, dateFormat)}`;
    }
    return '';
  }, [formatDate, to]);

  const formattedDateRange = useMemo(() => {
    if (formattedDateFrom && formattedDateTo) {
      return `${formattedDateFrom} - ${formattedDateTo}`;
    }
    return '';
  }, [formattedDateFrom, formattedDateTo]);

  return { formattedDateRange, formattedDateFrom, formattedDateTo, formatDate };
};

export { useDateFormatter };
